var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { state } from "lit/decorators.js";
export const AbstractDropdown = (Base) => {
    class AbstractDropdown extends Base {
        constructor() {
            super(...arguments);
            this._open = false;
            this._handleClickOutsideBind = this._handleClickOutside.bind(this);
            this._handleEscPressKeyBind = this._handleEscPressKey.bind(this);
        }
        get dropdownContainerElement() {
            return null;
        }
        focusFirstDropdownItem() { }
        focusMenuButton() { }
        set open(value) {
            if (value && !this._open) {
                document.addEventListener("click", this._handleClickOutsideBind, true);
                document.addEventListener("keyup", this._handleEscPressKeyBind, true);
            }
            else if (!value && this._open) {
                document.removeEventListener("click", this._handleClickOutsideBind, true);
                document.removeEventListener("keyup", this._handleEscPressKeyBind, true);
            }
            this._open = value;
        }
        get open() {
            return this._open;
        }
        toggleDropdown(event) {
            this.open = !this.open;
            event.stopPropagation();
            /*
           https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/menu_role
           When a menu opens, keyboard focus is placed on the first menu item. To be keyboard
           accessible, you need to manage focus for all descendants:
          */
            if (event) {
                this.dropdownContainerElement?.addEventListener("transitionend", () => {
                    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
                    this._handleDropdownMenuKeyboardFocus(event.detail === 0);
                }, { once: true });
            }
        }
        _handleClickOutside(event) {
            if (event?.target !== this &&
                event?.composedPath().every((target) => target !== this)) {
                this.open = false;
            }
        }
        _handleEscPressKey(e) {
            if (e?.code === "Escape") {
                this.open = false;
                this._handleDropdownMenuKeyboardFocus(true);
            }
        }
        _handleDropdownMenuKeyboardFocus(isFromKeyboard) {
            if (this.open && isFromKeyboard) {
                this.focusFirstDropdownItem();
            }
            else if (!this.open && isFromKeyboard) {
                this.focusMenuButton();
            }
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            window.removeEventListener("click", this._handleClickOutside, true);
            document.removeEventListener("keyup", this._handleEscPressKeyBind, true);
        }
    }
    __decorate([
        state()
    ], AbstractDropdown.prototype, "open", null);
    return AbstractDropdown;
};
